import axios from "./axios";

export const sendReserve = (body) => axios.post("/sendreserve", body);

export const paymentsCards = (body) => axios.post("/paymentCards", body);
export const completePaymentCard = (body) =>
  axios.post("/completePaymentCard", body);

export const getReservation = (body) => axios.post("/getReservation", body);
